// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { FilterEntry } from 'components/header/GenerateFilterEntry';

export enum DataFilterType {
  Dataset = 'dataset',
  ProcessTag = 'processTag',
  Label = 'label',
  ImageTag = 'imageTag',
  None = 'none',
}

export enum DatasetFilterType {
  EvaluationSet = 'evaluationSet',
  TrainingSet = 'trainingSet',
  UnLabeled = 'notLabeled',
}

export enum ProcessTagFilterType {
  GoodProcess = 'goodProcess',
  BadProcess = 'badProcess',
  Undefined = 'undefined',
  None = 'none',
}
export enum QCResult {
  Undefined = -1,
  Good = 0, // 0 = not failed = good
  Bad = 1, // 1 = failed = bad
}

export const isQCResultMatchingProcessTag = (qcResult: QCResult, processTag: ProcessTagFilterType) => {
  switch (processTag) {
    case ProcessTagFilterType.GoodProcess:
      return qcResult === QCResult.Good;
    case ProcessTagFilterType.BadProcess:
      return qcResult === QCResult.Bad;
    case ProcessTagFilterType.Undefined:
      return qcResult === QCResult.Undefined;
    case ProcessTagFilterType.None:
    default:
      return false;
  }
};

export interface DataFilter {
  dataset: DatasetFilterType[];
  processTag: ProcessTagFilterType[];
  label: string[];
  imageTag: string[];
}

export const dataFilters: FilterEntry[] = [
  {
    id: DataFilterType.Dataset,
    label: 'project.data.filters.dataset.title',
    options: [
      {
        id: DatasetFilterType.EvaluationSet,
        label: 'project.data.filters.dataset.evaluation',
      },
      {
        id: DatasetFilterType.TrainingSet,
        label: 'project.data.filters.dataset.training',
      },
      {
        id: DatasetFilterType.UnLabeled,
        label: 'project.data.filters.dataset.unlabeled',
      },
    ],
  },
  {
    id: DataFilterType.ProcessTag,
    label: 'project.data.filters.processTag.title',
    options: [
      {
        id: ProcessTagFilterType.GoodProcess,
        label: 'project.data.filters.processTag.goodProcess',
      },
      {
        id: ProcessTagFilterType.BadProcess,
        label: 'project.data.filters.processTag.badProcess',
      },
      {
        id: ProcessTagFilterType.Undefined,
        label: 'project.data.filters.processTag.undefined',
      },
    ],
  },
  {
    id: DataFilterType.Label,
    label: 'project.data.filters.label.title',
    options: [],
  },
  {
    id: DataFilterType.ImageTag,
    label: 'project.data.filters.imageTag.title',
    options: [],
  },
];
